import { getQueryParam } from '@mi-front/core';
import { UseQueryResult } from '@tanstack/react-query';
import { ViewError } from '@ui/utils';
import React from 'react';

interface PageLoaderProps {
  readonly skeleton: React.ReactNode;
  readonly children: React.ReactNode;
  readonly query: UseQueryResult;
}

/** Handles loading and error states for page content. */
export function PageLoader({ skeleton, children, query }: PageLoaderProps) {
  if (query.isLoading || getQueryParam('preview_skeleton')) {
    return skeleton;
  }

  if (query.error) {
    return <ViewError error={query.error} onRetry={() => query.refetch()} />;
  }

  return children;
}
